//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import adminSection from '~/mixins/admin-section'
import AdminSectionContent from '~/components/admin-sections/section-content.vue'

export default {
  name: 'AdminSectionFeaturesWithNumber',
  components: { AdminSectionContent },
  mixins: [adminSection],
  computed: {
    hasSectionTitle () {
      return this.getSectionTitle
    },
    getSectionTitle () {
      return this.section.title
    },
    hasSectionContent () {
      return this.getSectionContent
    },
    getSectionContent () {
      return this.section.content
    },
    getSectionItems () {
      return this.section.items.map((i) => {
        i.icon = 'v-check-circle'
        if (i?.raw_json?.['admin-section']?.icon) {
          i.icon = i?.raw_json?.['admin-section']?.icon
        }
        return i
      })
    }
  }
}
